import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScoreRegistrationRoutingModule } from './score-registration-routing.module';
import { ScoreRegistrationComponent } from './score-registration/score-registration.component';
import { ScoreRegistrationLandingComponent } from './score-registration-landing/score-registration-landing.component';
import { ScoreRegistrationLinkComponent } from './score-registration-link/score-registration-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    ScoreRegistrationComponent,
    ScoreRegistrationLandingComponent,
    ScoreRegistrationLinkComponent
  ],
  imports: [
    CommonModule,
    ScoreRegistrationRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class ScoreRegistrationModule { }
